import { Subject } from 'rxjs'
import { RxJS } from './RxJS'

const mainMenuTriggerSubject: Subject<Definable<boolean>> = new Subject<Definable<boolean>>()

RxJS.mainMenuTrigger = RxJS.mainMenuTrigger ?? {
    subject: mainMenuTriggerSubject,
    observable: mainMenuTriggerSubject.asObservable(),
    announce: (open?: boolean): void => {
        mainMenuTriggerSubject.next(open)
    }
}

export const mainMenuTrigger$ = RxJS.mainMenuTrigger
